'use client';

import { User } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { pagesRoutes } from '@/shared/constants/routes';
import { cn } from '@ecom/helper-react-class-combine';
import { TextNavLink } from '@/shared/components/text-nav-link';
import { LanguageSwitcher } from '@/features/layout/components/language-switcher';
import { AccountOptions } from '@/features/layout/components/account-options';
import { UserAuthSwitch } from '@/features/auth/shared/components/user-auth-switch';
import { Suspense } from 'react';

type UserActionLinksProps = {
  className?: string;
  onLinkClick?: () => void;
  isMobileView?: boolean;
};

export const UserActionLinks = ({
  className = '',
  onLinkClick,
  isMobileView = false,
}: UserActionLinksProps) => {
  const t = useTranslations('Home.header.userActions');

  return (
    <div className={cn('flex', className, isMobileView && 'flex-col gap-8')}>
      <UserAuthSwitch
        authenticated={<AccountOptions />}
        notAuthenticated={
          <div className='flex gap-2 px-2' role='group' aria-label={t('authOptions')}>
            <User size={20} fill='white' aria-hidden='true' />
            <TextNavLink
              isBold
              href={pagesRoutes.login.href}
              prefetch={false}
              onClick={onLinkClick}
              ariaLabel={t('signInToYourAccount')}
            >
              {t('signIn')}
            </TextNavLink>
            <span className='font-semibold' aria-hidden='true'>
              {t('or')}
            </span>
            <TextNavLink
              isBold
              href={pagesRoutes.register.href}
              prefetch={false}
              onClick={onLinkClick}
              ariaLabel={t('registerForANewAccount')}
            >
              {t('register')}
            </TextNavLink>
          </div>
        }
        loading={
          <span className='bg-background-panel mr-4 w-[200px] animate-pulse rounded-md'></span>
        }
      />
      <div className='flex' role='group' aria-label='Site preferences'>
        <div className='ml-auto'>
          <Suspense>
            <LanguageSwitcher />
          </Suspense>
        </div>
      </div>
    </div>
  );
};
